import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import { FaRegCommentAlt, FaFilter, FaSearch } from 'react-icons/fa';
import { AiFillLike, AiOutlineLike } from 'react-icons/ai';
import api from '../../services/api';
import FeedLayout from '../Includes/FeedLayout';
import Perfil from '../../assests/avatar.png';
import { calculaTempo } from '../../global';
import { TextoComBandeiras, inserirBandeirasHtml, cortarTexto } from '../../bandeiras';
import Linkify from 'linkifyjs/react';
import { useTranslation } from 'react-i18next';

import * as linkify from 'linkifyjs';
import hashtag from 'linkifyjs/plugins/hashtag';
import blockchainImg from '../../assests/blockchain.svg';

import './styles.css';

hashtag(linkify);

function isPremiumPlan() {
  try {
    return JSON.parse(sessionStorage.getItem('plan')).content === 'premium';
  } catch (err) {
    return false;
  }
}

export default function Timeline() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { page: rotaTag } = useParams();
  const hashTag = rotaTag || sessionStorage.getItem('hashTag');
  const sentinelRef = useRef(null);
  const loadingRef = useRef(false);

  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [busca, setBusca] = useState('');
  const [textoBusca, setTextoBusca] = useState('');
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [zoomImg, setZoomImg] = useState(null);
  const [verClassificados, setVerClassificados] = useState(
    () => !rotaTag && sessionStorage.getItem('timelineClassificados') === '1'
  );

  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const BASE_URL = sessionStorage.getItem('BASE_URL');
  const PARAMS = '';
  const userTags = JSON.parse(sessionStorage.getItem('tags') || 'null') || [];

  useEffect(() => {
    api.get('/v4/tags', {
      headers: {
        USER_EMAIL,
        USER_TOKEN,
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      sessionStorage.setItem('TAGS', JSON.stringify(response.data));
    }).catch(() => {});
  }, [USER_EMAIL, USER_TOKEN]);

  useEffect(() => {
    const view = location.state && location.state.view;
    if (rotaTag) {
      sessionStorage.setItem('hashTag', rotaTag);
      sessionStorage.setItem('timelineClassificados', '');
      setVerClassificados(false);
      return undefined;
    }
    if (view === 'classifieds' || sessionStorage.getItem('timelineClassificados') === '1') {
      sessionStorage.setItem('hashTag', '');
      setVerClassificados(true);
      return undefined;
    }
    sessionStorage.setItem('hashTag', '');
    setVerClassificados(false);
    if (view === 'todos') {
      setBusca('');
      setTextoBusca('');
      setPage(1);
    }
    return undefined;
  }, [rotaTag, location.key, location.state]);

  useEffect(() => {
    let cancelled = false;
    loadingRef.current = true;
    setLoadingMore(true);

    var url = (hashTag !== '' && hashTag !== null)
      ? `/v6/posts?page=${page}&by_kind=feed&by_tag=${hashTag}`
      : `/v4/posts?page=${page}&by_kind=feed`;
    if (busca !== '') {
      url = `/v6/posts?page=${page}&by_kind=feed&by_term=${encodeURIComponent(busca)}`;
    }
    if (verClassificados) {
      url = `/v6/classifieds?page=${page}`;
    }

    api.get(url, {
      headers: {
        USER_EMAIL,
        USER_TOKEN,
        PARAMS,
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (cancelled) return;
      const data = Array.isArray(response.data) ? response.data : [];
      setPosts((prev) => (page === 1 ? data : prev.concat(data)));
      setHasMore(data.length > 0);
      if (!verClassificados) {
        sessionStorage.setItem('sPosts', JSON.stringify(data));
        sessionStorage.setItem('page', page);
      }
    }).catch(() => {
      if (!cancelled) history.push('/');
    }).finally(() => {
      if (!cancelled) {
        loadingRef.current = false;
        setLoadingMore(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [USER_EMAIL, USER_TOKEN, busca, hashTag, history, location.key, page, verClassificados]);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      if (loadingRef.current || !hasMore) return;
      setPage((current) => current + 1);
    }, { rootMargin: '240px' });
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, posts.length]);

  useEffect(() => {
    if (!zoomImg) return undefined;
    function onKey(e) {
      if (e.key === 'Escape') setZoomImg(null);
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [zoomImg]);

  function Description(props) {
    let texto = cortarTexto(props.texto || '', 220);
    let download = props.download;
    var regex = /(.*?:)/g;
    texto = texto.replace(regex, function (matched) {
      return `<b>${matched}</b>`;
    });
    texto = inserirBandeirasHtml(texto);

    if (!isPremiumPlan()) {
      if (texto.indexOf('Composição do preço:') !== -1) {
        var teste = texto.substring(texto.indexOf('Composição do preço:') + 20, texto.indexOf('\r\n<b>Data de negociação'));
        texto = texto.replace(teste, `<a href="/sempermissao" id="link-premium">${t('pages.timeline.view_more')}</a>`);
      }
    }

    if (download) {
      return (
        <>
          <Linkify options={linkifyOptions}>
            <p className="description" dangerouslySetInnerHTML={{ __html: texto }} />
          </Linkify>
          <p className="file"><a href={download} target="blank">{t('pages.timeline.download')}</a></p>
        </>
      );
    }
    return (
      <Linkify options={linkifyOptions}>
        <p className="description" dangerouslySetInnerHTML={{ __html: texto }} />
      </Linkify>
    );
  }

  function curtir(id, evaluation) {
    const nextValue = evaluation === null ? true : null;
    var axios = require('axios');
    var data = JSON.stringify({ evaluation: nextValue });
    var config = {
      method: 'post',
      url: BASE_URL + `/v6/posts/${id}/evaluate`,
      headers: {
        'Content-Type': 'application/json',
        USER_EMAIL,
        USER_TOKEN,
      },
      data,
    };
    axios(config)
      .then(function () {
        setPosts((prev) => prev.map((post) => {
          if (post.id !== id) return post;
          const liked = nextValue === true;
          const count = parseInt(post.ups_count, 10) || 0;
          return {
            ...post,
            evaluation: liked,
            ups_count: liked ? count + 1 : Math.max(0, count - 1),
          };
        }));
      })
      .catch(function () {
        history.push('/');
      });
  }

  function Like(props) {
    var evaluation = props.evaluation;
    if (evaluation === true) {
      return (
        <button type="button" onClick={() => curtir(props.id, evaluation)}>
          <AiFillLike size={18} color="#00b8ff" />
          <span className="like">{props.count}</span>
        </button>
      );
    }
    return (
        <button type="button" onClick={() => curtir(props.id, null)}>
          <AiOutlineLike size={18} color="#6b7280" />
          <span className="like">{props.count}</span>
        </button>
    );
  }

  function Imagem(props) {
    if (!props.url || props.url === 'null') return null;
    return (
      <img
        className="feed-photo"
        src={props.url}
        alt=""
        onClick={() => setZoomImg(props.url)}
      />
    );
  }

  function abrirFiltro() {
    history.push('/timelinebusca');
  }

  function aplicarBusca(palavra) {
    const termo = String(palavra || '').trim();
    sessionStorage.setItem('timelineClassificados', '');
    setVerClassificados(false);
    setPosts([]);
    setHasMore(true);
    setPage(1);
    setBusca(termo);
    setTextoBusca(termo);
  }

  function buscarPorPalavra() {
    aplicarBusca(textoBusca);
  }

  function verificaEnter(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      aplicarBusca(e.target.value);
    }
  }

  function carregarTag(slug) {
    sessionStorage.setItem('timelineClassificados', '');
    setVerClassificados(false);
    sessionStorage.setItem('hashTag', slug);
    setBusca('');
    setTextoBusca('');
    setPosts([]);
    setHasMore(true);
    setPage(1);
    history.push(slug ? `/timeline/${slug}` : '/timeline');
  }

  function carregarClassificados() {
    sessionStorage.setItem('hashTag', '');
    sessionStorage.setItem('timelineClassificados', '1');
    setVerClassificados(true);
    setBusca('');
    setTextoBusca('');
    setPosts([]);
    setHasMore(true);
    setPage(1);
    history.push({ pathname: '/timeline', state: { view: 'classifieds' } });
  }

  var linkifyOptions = {
    formatHref: function (href, type) {
      if (type === 'hashtag') {
        href = '#' + href.substring(1);
      }
      return href;
    },
  };

  const premium = isPremiumPlan();

  return (
    <FeedLayout active="timeline">
      <div className="feed-top">
        {busca
          ? t('pages.timeline.title.withSearch') + busca
          : (verClassificados
            ? `TIMELINE / ${t('pages.includes.filters.classified')}`
            : (hashTag === null || hashTag === ''
              ? t('pages.timeline.title.withoutHashTag')
              : t('pages.timeline.title.withHashTag') + hashTag))}
      </div>

      <div className="feed-toolbar">
        <div className="feed-search">
          <input
            id="txtBusca"
            value={textoBusca}
            onChange={(e) => setTextoBusca(e.target.value)}
            onKeyDown={verificaEnter}
            placeholder="Buscar publicações"
          />
          <button
            type="button"
            className="feed-search-btn"
            onClick={buscarPorPalavra}
            title="Buscar"
            aria-label="Buscar"
          >
            <FaSearch />
          </button>
        </div>
        <button type="button" className="feed-icon-btn" onClick={abrirFiltro} title="Filtros">
          <FaFilter />
        </button>
      </div>

      <div className="feed-chips">
        <button type="button" className={!hashTag && !verClassificados && !busca ? 'is-active' : ''} onClick={() => carregarTag('')}>
          {t('pages.includes.filters.all')}
        </button>
        <button
          type="button"
          className={verClassificados ? 'is-active' : ''}
          onClick={carregarClassificados}
        >
          {t('pages.includes.filters.classified')}
        </button>
        {userTags.map((tag) => (
          <button
            type="button"
            key={tag.id || tag.slug}
            className={!verClassificados && hashTag === tag.slug ? 'is-active' : ''}
            onClick={() => carregarTag(tag.slug)}
          >
            {tag.name}
          </button>
        ))}
      </div>

      <section className="feed-body">
        <ul>
          {verClassificados ? posts.map((post) => {
            const avatar = post.user_info && post.user_info.avatar && post.user_info.avatar.medium
              ? post.user_info.avatar.medium
              : Perfil;
            const city = (post.city_info && post.city_info.name) || '';
            const state = (post.state_info && post.state_info.acronym) || '';
            return (
              <li key={post.id}>
                <div className="post-content">
                  <p className="nomeProf">
                    <img className="imgProf" src={avatar} alt="" />
                    <span>
                      <span className="nome">{post.user_info && post.user_info.name}</span>
                      <span className="tempo"> · {calculaTempo(post.created_at)}</span>
                    </span>
                  </p>
                  <div className="containerTag">
                    <div className="tags">
                      {post.category ? (
                        <div className="clTag">
                          <span>#{post.category}</span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <p className="title"><TextoComBandeiras texto={post.title} /></p>
                  <p className="feed-ad-value">
                    {Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(post.value)}
                  </p>
                  <Imagem url={post.image_url || null} />
                  <p className="feed-ad-city">{city}{city && state ? '/' : ''}{state}</p>
                  <p className="description">{post.description}</p>
                  {post.observation ? <p className="description">{post.observation}</p> : null}
                  <p className="lermais">
                    <Link
                      to={'/meus-anuncios/detalhe/' + post.id}
                      onClick={() => sessionStorage.setItem('adFrom', 'timeline')}
                    >
                      {t('pages.classifieds.more')}
                    </Link>
                  </p>
                </div>
              </li>
            );
          }) : posts.map((post) => (
            <li key={post.id}>
              {post.best_negotiation_of_the_day && (
                <div className="best-negotiation-of-the-day">
                  {t('pages.timeline.bestNegotiation')}
                </div>
              )}

              {post.is_validated && (
                <div className="blockchain blockchain-timeline">
                  <span className="blockchain-text">{t('pages.timeline.validatedOnBlockChain')}</span>
                  <img src={blockchainImg} alt={t('pages.timeline.alt.blockchain')} />
                </div>
              )}

              <div className="post-content">
                <p className="nomeProf">
                  <img
                    className="imgProf"
                    src={post.user && post.user.avatar && post.user.avatar.medium ? post.user.avatar.medium : Perfil}
                    alt={t('pages.timeline.alt.profile')}
                  />
                  <span>
                    <span className="nome">{post.user && post.user.name}</span>
                    <span className="tempo"> · {calculaTempo(post.created_at)}</span>
                  </span>
                </p>
                <div className="containerTag">
                  <div className="tags">
                    {(post.tags || []).map((tag) => (
                      <div className="clTag" key={tag.id}>
                        <span>{tag.name}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <p className="title"><TextoComBandeiras texto={post.title} /></p>

                {(post.is_free_visible || premium) && (
                  <>
                    <Description texto={post.description || ''} download={post.file} />
                    <Imagem
                      url={post.image ? (post.image.original || post.image.medium) : null}
                    />
                    <p className="lermais">
                      <Link to={`/post/${post.id}`} className="lermais">{t('pages.timeline.keepReading')}</Link>
                    </p>
                  </>
                )}

                {(!post.is_free_visible && !premium) && (
                  <>
                    <a href="/sempermissao">
                      <div className="post-content-premium">
                        <span>{t('pages.timeline.only_for_premium')}</span>
                      </div>
                    </a>
                    <p className="lermais">
                      <a href="/sempermissao" className="lermais">{t('pages.timeline.keepReading')}</a>
                    </p>
                  </>
                )}

                <p className="icons">
                  <Like count={post.ups_count} id={post.id} evaluation={post.evaluation} />
                  <span className="coment">
                    <FaRegCommentAlt size={18} color="#6b7280" />
                    <span className="like">{(post.first_comments || []).length}</span>
                  </span>
                </p>
              </div>
            </li>
          ))}
        </ul>
        <div className="feed-sentinel" ref={sentinelRef}>
          {loadingMore && <span>{verClassificados ? 'Carregando mais classificados…' : 'Carregando mais publicações…'}</span>}
          {!loadingMore && !hasMore && posts.length > 0 && (
            <span>{verClassificados ? 'Você viu os classificados mais recentes' : 'Você viu as publicações mais recentes'}</span>
          )}
        </div>
      </section>
      {zoomImg && (
        <div className="img-zoom" onClick={() => setZoomImg(null)} role="dialog" aria-modal="true">
          <button type="button" className="img-zoom-close" onClick={() => setZoomImg(null)} aria-label="Fechar">×</button>
          <img src={zoomImg} alt="" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </FeedLayout>
  );
}
